<script setup>
import useStaff from "~/modules/staff";

const route = useRoute();

const { getTroupe, getInvitedArtists } = useStaff();

const { data: state, pending: isLoaded } = await useAsyncData(
  "get troupe list",
  async () => {
    try {
      const troupe = await getTroupe();
      const invited = await getInvitedArtists();

      return { troupe, invited };
    } catch (error) {
      console.error(error);
    }
  }
);

useHead({
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Труппа | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Труппа | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <div v-if="state">
        <r-section title=" ">
          <div class="grid grid-cols-2 lg:grid-cols-3 gap-x-7 gap-y-10">
            <template v-for="person in state.troupe" :key="person._id">
              <RTroupeCart
                :person="person"
                v-if="person.sortKey != 0"
              ></RTroupeCart>
            </template>
          </div>
        </r-section>
        <r-section title="Приглашенные артисты">
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-7 gap-y-10">
            <template v-for="person in state.invited" :key="person._id">
              <RTroupeCart
                :person="person"
                type="small"
                v-if="person.sortKey != 0"
              ></RTroupeCart>
            </template>
          </div>
        </r-section>
      </div>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
